import { useMemo, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AttendanceLocal } from "../../../../../../../../../@types/attendance-local";
import { useServiceAvailableList } from "../../../../../../../../../services/api-tansquery/service-available-list";
import { useDebouncedValue } from "../../../../../../../../../hooks/useDebounce";
import { ServiceAvailable } from "../../../../../../../../../@types/service-available";

type Props = {
    slug: AttendanceLocal["slug_unidade"];
    field: ControllerRenderProps<{
        servico_id?: string;
        unidade?: string;
        agendamento?: boolean;
        atendimento?: boolean;
    }, "servico_id">
    fieldState: ControllerFieldState
    style?: React.CSSProperties;
}

export default function ServiceField({ slug, field, fieldState, style }: Props) {
    const [search, setSearch] = useState<string>();
    const debouncedSearch = useDebouncedValue(search, 500);
    const { data: serviceList, isLoading } = useServiceAvailableList({
        search: debouncedSearch, unidade: slug, page: 1, items_size: 1000
    });

    const options = useMemo(() => {
        return serviceList?.results || [];
    }, [serviceList]);

    const selected = useMemo(() => {
        return serviceList?.results.find(
            (service) => service.id === Number(field.value)
        ) || null;
    }, [serviceList, field.value]);

    function handleInputChange(_, value: string, reason: string) {
        if (reason === "input") {
            setSearch(value.trim() === "" ? undefined : value);
        }
    }

    function handleChange(_, newValue: ServiceAvailable | null) {
        if (!newValue) {
            field.onChange("");
        } else {
            field.onChange(newValue.id.toString());
        }
    }

    return (
        <Autocomplete
            style={style}
            freeSolo={false}
            options={options}
            value={selected}
            onChange={handleChange}
            onInputChange={handleInputChange}
            getOptionLabel={(option) => option.titulo}
            getOptionSelected={(option, value) => option.id === value.id}
            loading={isLoading}
            loadingText="Carregando serviços..."
            noOptionsText="Nenhum serviço encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    required
                    label="Serviço"
                    variant="outlined"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message || "Selecione um serviço"}
                    InputProps={{
                        ...params.InputProps,
                        required: false,
                        endAdornment: (
                            <>
                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}